import React, {Component} from 'react';
import Footer from '../exercise/Footer';
import GridesView from '../ai_sudoku/gridesView';
import {Button,Tabs} from 'antd';
import {view as QuestionView} from '../question_view';

const $ = require('$');
const {TabPane} = Tabs;

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    toggleAnswer = (val, e) => {
        e.stopPropagation();
        this.setState({visible: val});
    };
    componentDidMount() {
        if(this.props.data.subject==='0'){
            this.setState({visible:true})  //数学题默认答案显示
        }
    }


    componentDidUpdate() {
    }

    createHtml = str => ({__html: str ? str : `&nbsp;`});

    onExpand = (val) => {//展开
        let hideSub = val
        this.setState({hideSub})

    };

    render() {

        const childHtml = (exercise) => {
            return <div key={exercise.number}>

                {
                    <QuestionView data={exercise} isSub={true} num={parseInt(exercise.number) - 1}/>
                }
            </div>;
        };

        const {visible} = this.state;
        let originData = this.props.data;
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案

        const {num, children} = this.props;
        let stem = originData.stem
        stem = JSON.parse(stem)
        return (
            <div className="box-exercise" ref={'viewer'}>

                <div className="exercise-content">
                    <Button style={{position:'absolute',top:'10px',right:'10px',opacity:'0.5'}} type={'primary'} onClick={() => {this.onExpand(!this.state.hideSub)}}>{this.state.hideSub?'隐藏子题':'显示子题'}</Button>
                    {num!=='undefined'&&<div className="exercise-num"><p className="math_text">{`${num + 1}、`}</p></div>}
                    <div className="exercise-con" >
                        答案：
                        <GridesView
                                type={stem.type}
                                show_list={stem.answer_list}
                                />
                    </div>

                </div>
                <div className="exercise-footer">

                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible,e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>

                </div>
                {
                    this.state.hideSub&&
                    <div style={{borderLeft: '2px solid #00b1fe', marginLeft: -1}}>
                        {
                            originData.sub_list.map(item=>
                                childHtml(item)
                            )
                        }
                    </div>
                }
            </div>


        )
    }
}


export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/ai_sudoku_parent/viewForView.js